import axios from "axios";
import { CustomImage } from "burde";

export const uploadOwnerPageImage = async (
    blob: Blob,
): Promise<CustomImage | null> => {
    try {
        const config = {
            headers: { "content-type": "multipart/form-data" },
        };

        const data = new FormData();
        data.append("File", blob);

        const response = await axios.post(
            "api/ImageUpload/UploadOwnerImage",
            data,
            config,
        );

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    } catch (e) {
        return null;
    }
};
